import { apiClient, handleApiError } from './api.js';

class DashboardService {
  // Get dashboard summary statistics
  async getDashboardSummary() {
    try {
      return await apiClient.get('/dashboard/summary');
    } catch (error) {
      console.error('Error getting dashboard summary:', error);
      throw error;
    }
  }

  // Get recent appointments
  async getRecentAppointments(limit = 5) {
    try {
      return await apiClient.get(`/dashboard/recent-appointments?limit=${limit}`);
    } catch (error) {
      console.error('Error getting recent appointments:', error);
      throw error;
    }
  }

  // Get today's appointments
  async getTodayAppointments() {
    try {
      return await apiClient.get('/dashboard/today-appointments');
    } catch (error) {
      console.error('Error getting today appointments:', error);
      throw error;
    }
  }

  // Get upcoming appointments
  async getUpcomingAppointments(limit = 5) {
    try {
      return await apiClient.get(`/dashboard/upcoming-appointments?limit=${limit}`);
    } catch (error) {
      console.error('Error getting upcoming appointments:', error);
      throw error;
    }
  }

  // Get recent patients
  async getRecentPatients(limit = 5) {
    try {
      return await apiClient.get(`/dashboard/recent-patients?limit=${limit}`);
    } catch (error) {
      console.error('Error getting recent patients:', error);
      throw error;
    }
  }

  // Get low stock inventory items
  async getLowStockItems(limit = 5) {
    try {
      return await apiClient.get(`/dashboard/low-stock?limit=${limit}`);
    } catch (error) {
      console.error('Error getting low stock items:', error);
      throw error;
    }
  }

  // Get revenue statistics
  async getRevenueStatistics(period = 'month') {
    try {
      return await apiClient.get(`/dashboard/revenue?period=${period}`);
    } catch (error) {
      console.error('Error getting revenue statistics:', error);
      throw error;
    }
  }

  // Get appointment statistics
  async getAppointmentStatistics(period = 'month') {
    try {
      return await apiClient.get(`/dashboard/appointment-stats?period=${period}`);
    } catch (error) {
      console.error('Error getting appointment statistics:', error);
      throw error;
    }
  }

  // Get patient statistics
  async getPatientStatistics(period = 'month') {
    try {
      return await apiClient.get(`/dashboard/patient-stats?period=${period}`);
    } catch (error) {
      console.error('Error getting patient statistics:', error);
      throw error;
    }
  }
  
  // Get billing statistics
  async getBillingStatistics(period = 'month') {
    try {
      return await apiClient.get(`/dashboard/billing-stats?period=${period}`);
    } catch (error) {
      console.error('Error getting billing statistics:', error);
      throw error;
    }
  }
  
  // Get inventory statistics
  async getInventoryStatistics() {
    try {
      return await apiClient.get('/dashboard/inventory-stats');
    } catch (error) {
      console.error('Error getting inventory statistics:', error);
      throw error;
    }
  }
}

export default new DashboardService();